import zodToJsonSchema from 'zod-to-json-schema';
import { z } from 'zod';

function makeFieldSchema(options) {
  const { output, uiOptions } = options;
  return {
    TProps: void 0,
    schema: {
      returnValue: zodToJsonSchema(output(z)),
      uiOptions: uiOptions && zodToJsonSchema(uiOptions(z))
    },
    // These will be removed - just here for backwards compat whilst we're moving across
    type: void 0,
    uiOptionsType: void 0
  };
}

export { makeFieldSchema };
//# sourceMappingURL=utils.esm.js.map
